'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _Utils = require('./Utils');

var Utils = _interopRequireWildcard(_Utils);

var _StackAnimates = require('./StackAnimates');

var _StackAnimates2 = _interopRequireDefault(_StackAnimates);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Animate = function (_PureComponent) {
  _inherits(Animate, _PureComponent);

  function Animate() {
    _classCallCheck(this, Animate);

    return _possibleConstructorReturn(this, (Animate.__proto__ || Object.getPrototypeOf(Animate)).apply(this, arguments));
  }

  _createClass(Animate, [{
    key: 'render',
    value: function render() {
      var Animation = this.props.Animation;


      if (Utils.isArray(Animation)) {
        return _react2.default.createElement(_StackAnimates2.default, this.props);
      }

      return _react2.default.createElement(
        Animation,
        this.props,
        this.props.children
      );
    }
  }]);

  return Animate;
}(_react.PureComponent);

exports.default = Animate;


//////////////////
// WEBPACK FOOTER
// ./~/animate-css-styled-components/lib/Animate/index.js
// module id = 486
// module chunks = 95715928098905 168707334958949